import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import deepEqual from 'deep-equal'
import deepcopy from 'deepcopy'
import _ from 'lodash'
import AddonContentInside from './AddonContentInside';

class AddonContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      settings: this.props.addon.settings,
      htmlContent: '',
      cssContent: '',
      insideAddons: {}
    };
  }

  checkGoogleFont(addon){
    let head = window.frames['sp-pagebuilder-view'].window.document.head;
    let doc = window.frames['sp-pagebuilder-view'].window.document;
    let addonOpt = addonsJSON[addon.name];

    const systemFonts = [
      'System',
      'Google Fonts',
      'Arial',
      'Tahoma',
      'Verdana',
      'Helvetica',
      'Times New Roman',
      'Trebuchet MS',
      'Georgia',
    ]

    if(addonOpt.attr !== undefined && addonOpt.attr.general !== undefined){
      _.each(addonOpt.attr.general, (optValues, optName) => {
        
        if(optValues.type == 'fonts') {

          this.addFont(addon.id, addon.settings, optName, addon.settings[optName], optValues)
          
        } else if(optValues.attr !== undefined && addon.settings[`sp_${addon.name}_item`] !== undefined){
          _.each(addon.settings[`sp_${addon.name}_item`], (item, index) => {
            _.each(optValues.attr, (optValues, optName) => {
              if(optValues.type == 'fonts') {

                let otherId = ''
  
                if(addon.name == 'button_group'){
                  otherId = `#btn-${addon.id}${index}`
                }
                
                this.addFont(addon.id, item, optName, item[optName], optValues, otherId, index)
              }

            })
          })
        }
      });
    }
  }

  addFont(id, settings, optName, value, optValues, otherId = '', index = ''){
    let head = window.frames['sp-pagebuilder-view'].window.document.head;
    let doc = window.frames['sp-pagebuilder-view'].window.document;

    const systemFonts = [
      'System',
      'Google Fonts',
      'Arial',
      'Tahoma',
      'Verdana',
      'Helvetica',
      'Times New Roman',
      'Trebuchet MS',
      'Georgia',
    ]

    if(optValues.selector !== undefined){
      let style = head.querySelector('#addon-css-'+id+index+'_'+optName);

      if(style && value !== undefined){
        style.innerHTML = `#sppb-addon-${id} ${otherId}${optValues.selector.css.replace("{{ VALUE }}", value)}`
      } else if(value !== undefined) {
        style =  doc.createElement('style');
        style.id = 'addon-css-'+id+index+'_'+optName;
        style.type = 'text/css';

        head.appendChild(style);

        style.innerHTML = `#sppb-addon-${id} ${otherId}${optValues.selector.css.replace("{{ VALUE }}", value)}`
      }

    }

    if(settings !== undefined && value !== undefined){
      var fontLink =  head.querySelector('#google-font-'+value.toLowerCase().replace(" ", "_"));

      if(!fontLink && systemFonts.indexOf(value) === -1){
        let googleFontLink = 'https://fonts.googleapis.com/css?family='+value+':100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic';

              let fontLink =  doc.createElement('link');
              fontLink.id = 'google-font-'+value.toLowerCase().replace(" ", "_");
              fontLink.href = googleFontLink;
              fontLink.rel = 'stylesheet';
              fontLink.type = 'text/css';

              head.appendChild(fontLink);
      }
    }
  }

  addonAssets() {
    const { addon } = this.props;

    if(addon.name == 'gmap' && typeof initSPPageBuilderGMap !== 'undefined') {
      initSPPageBuilderGMap(window.frames['sp-pagebuilder-view'].window.document);
    }

    if( typeof addonsJSON[addon.name] == 'undefined' ){
      return;
    }

    this.checkGoogleFont(addon);

    if(addonsJSON[addon.name].js_template){
      return;
    }

    let assets = addon.assets;

    if(addon.assets == undefined){
      assets = this.state.cssContent;
    }
    // assets
    if(assets != '') {
      // CSS
      if(assets.css != undefined) {
        var css = window.frames['sp-pagebuilder-view'].window.document.createElement('style');
        css.setAttribute( 'type', 'text/css' );
        css.id = 'addon-style-' + addon.id;

        if(window.frames['sp-pagebuilder-view'].window.document.getElementById(css.id) != undefined) {
          window.frames['sp-pagebuilder-view'].window.document.getElementById(css.id).remove();
        }

        if (css.styleSheet) {
          css.styleSheet.cssText = assets.css;
        } else {
          css.appendChild(window.frames['sp-pagebuilder-view'].window.document.createTextNode(assets.css));
        }

        window.frames['sp-pagebuilder-view'].window.document.getElementsByTagName('head')[0].appendChild( css );
      }

      // JS
      if(assets.js != undefined) {
        var script = window.frames['sp-pagebuilder-view'].window.document.createElement('script');
        script.setAttribute( 'type', 'text/javascript' );
        script.id = 'addon-script-' + addon.id;
        script.setAttribute( 'async', true );
        script.text = assets.js;
        window.frames['sp-pagebuilder-view'].window.document.getElementsByTagName('head')[0].appendChild( script );
      }
    }


  }

  componentDidMount(){
    const { addon } = this.props;
    this.addonAssets();
  }

  shouldComponentUpdate( nextProps, nextState ) {
    if( !deepEqual( nextProps.addon.settings, nextState.settings ) ) {
      return true;
    }

    if(nextState.htmlContent != ''){
      return true;
    }

    if( !deepEqual( this.state.insideAddons, nextState.insideAddons ) ) {
      return true;
    }

    return false;
  }

  componentDidUpdate(){
    const { settings } = this.state;
    const { addon } = this.props;

    if( !deepEqual( this.props.addon.settings, settings ) ) {
      this.setState({
        settings: this.props.addon.settings,
      });
    }

    this.addonAssets();

  }

  renderAddon(){

    const { addon } = this.props;

    _.templateSettings.evaluate = /<#([\s\S]+?)#>/g;
    _.templateSettings.interpolate = /\{\{\{([\s\S]+?)\}\}\}/g;
    _.templateSettings.escape = /\{\{([^\}]+?)\}\}(?!\})/g;
    _.templateSettings.variable = 'data';

    let template = document.getElementById('sppb-tmpl-addon-'+addon.name);

    let addonMain = deepcopy(addon);

    if(addonMain.name == 'accordion'){

      if(!_.isEmpty(addonMain.settings.sp_accordion_item)){
        addonMain.settings.sp_accordion_item = addonMain.settings.sp_accordion_item.map((accordion_item, index) => {
          if(_.isArray(accordion_item.content)){
            accordion_item.content = accordion_item.content.map((insideAddon, key) => {
              let itemKey = `sppbai-${index}-${key}`;
              this.checkGoogleFont(insideAddon);
              if(typeof this.state.insideAddons[itemKey] === 'undefined' || _.isEmpty(this.state.insideAddons[itemKey]) || !deepEqual(this.state.insideAddons[itemKey].settings, insideAddon.settings)){
                return this.renderInsideAddon(insideAddon, key, index);
              } else {
                return this.state.insideAddons[itemKey].html;
              }

            });
          }

          return accordion_item;
        });
      }
    } else if(addonMain.name == 'sp_tab' || addonMain.name == 'tab'){
      if(!_.isEmpty(addonMain.settings.sp_tab_item)){
        addonMain.settings.sp_tab_item = addonMain.settings.sp_tab_item.map((tab_item, index) => {
          if(_.isArray(tab_item.content)){
            tab_item.content = tab_item.content.map((insideAddon, key) => {
              let itemKey = `sppbai-${index}-${key}`;
              this.checkGoogleFont(insideAddon);
              if(typeof this.state.insideAddons[itemKey] === 'undefined' || _.isEmpty(this.state.insideAddons[itemKey]) || !deepEqual(this.state.insideAddons[itemKey].settings, insideAddon.settings)){
                return this.renderInsideAddon(insideAddon, key, index);
              } else {
                return this.state.insideAddons[itemKey].html;
              }

            });
          }

          return tab_item;
        });
      }
    } else if(addonMain.name == 'sp_carouselpro' || addonMain.name == 'carouselpro'){
      if(!_.isEmpty(addonMain.settings.sp_carouselpro_item)){
        addonMain.settings.sp_carouselpro_item = addonMain.settings.sp_carouselpro_item.map((carouselpro_item, index) => {
          if(_.isArray(carouselpro_item.content)){
            carouselpro_item.content = carouselpro_item.content.map((insideAddon, key) => {
              let itemKey = `sppbai-${index}-${key}`;
              this.checkGoogleFont(insideAddon);
              if(typeof this.state.insideAddons[itemKey] === 'undefined' || _.isEmpty(this.state.insideAddons[itemKey]) || !deepEqual(this.state.insideAddons[itemKey].settings, insideAddon.settings)){
                return this.renderInsideAddon(insideAddon, key, index);
              } else {
                return this.state.insideAddons[itemKey].html;
              }

            });
          }

          return carouselpro_item;
        });
      }
    }


    if(template){
      var compiled = _.template(template.innerHTML);

      addonMain.settings.id = addonMain.id;

      return compiled(addonMain.settings);
    }

    if(!template && typeof addon.htmlContent === 'undefined' && this.state.htmlContent == ''){
      jQuery.ajax({
          type: 'POST',
          url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=addon',
          dataType: 'json',
          data: {
            addon: addon
          },
          cache: false,
          success: function(response) {

            if(response.status == 'true'){

              this.setState({
                htmlContent: response.html,
                cssContent: response.assets
              })
            }
          }.bind(this)
        });
    } else if(this.state.htmlContent){
      return this.state.htmlContent;
    }

    return addon.htmlContent;
  }

  renderInsideAddon(insideAddon, key, index){
    let template = document.getElementById('sppb-tmpl-addon-'+insideAddon.name);

    let insideAddonMain = deepcopy(insideAddon);

    if(template){
      var compiled = _.template(template.innerHTML);

      insideAddonMain.settings.id = insideAddonMain.id;

      return compiled(insideAddonMain.settings);
    }

    let itemKey = `sppbai-${index}-${key}`;

    if(!template && ( typeof this.state.insideAddons[itemKey] === 'undefined' || _.isEmpty(this.state.insideAddons[itemKey]) || !deepEqual(this.state.insideAddons[itemKey].settings, insideAddonMain.settings)) ){
      jQuery.ajax({
          type: 'POST',
          url: pagebuilder_base + 'index.php?option=com_sppagebuilder&view=ajax&format=json&callback=addon',
          dataType: 'json',
          data: {
            addon: insideAddon,
          },
          cache: false,
          success: function(response) {

            if(response.status == 'true'){
              let insideAddons = deepcopy(this.state.insideAddons);

              insideAddons[itemKey] = {
                html: response.html,
                assets: response.assets,
                settings: insideAddonMain.settings
              }

              this.setState({
                insideAddons: insideAddons
              })
            }
          }.bind(this)
        });
    } else if( typeof this.state.insideAddons[itemKey] !== 'undefined' && !_.isEmpty(this.state.insideAddons[itemKey]) ){
      return this.state.insideAddons[itemKey].html;
    }

    return insideAddon.htmlContent || '';
  }

  render() {
    const { addon, editAddon } = this.props;

    let htmlContent = this.renderAddon()

    if(this.state.htmlContent != ''){
      htmlContent = this.state.htmlContent
    }

    let addonIdForCSS = 'sppb-addon-' + addon.id;

    if(_.isEmpty(htmlContent)){
      htmlContent = `<div class="sppb-empty-addon">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="140.1px" height="24.2px" viewBox="0 0 140.1 24.2" >
                      <path class="st0" d="M19,13.5c-0.4-0.4-0.8-0.4-1.1,0.1c-0.9,1.1-1.9,2.1-2.9,3c-3.5,3-7.6,4.7-12.1,5.5
                          c-0.6,0.1-0.8-0.1-0.8-0.7c0-0.9,0-1.9,0-2.8l0,0l0,0l0,0V5.5V4.9c0-0.2,0-0.4,0.3-0.5c0.4-0.3,0.7,0.2,1.1,0.5
                          c3.4,2.4,6.8,4.9,10.2,7.3c0.5,0.3,0.5,0.5,0.1,0.9c-2.6,2.4-5.5,4.1-8.9,5.1c-1.2,0.3-1.2,0.3-1.2,1.6c0,0.5,0.1,0.6,0.6,0.5
                          c1-0.2,2-0.5,2.9-0.8c3.7-1.4,6.8-3.5,9.4-6.5c0.6-0.7,0.6-0.6-0.1-1.2C11.1,7.9,5.9,4.2,0.7,0.5C0.6,0.4,0.4,0.3,0.3,0.4
                          c-0.2,0-0.1,0.2-0.1,0.4c0,0.9,0,1.8,0,2.7c0,0.3,0,0.4,0,0.6v3.2l0,0v2.6v1.2V13v1.4v1.5l0,0l-0.1,4.3l0,0c0,0.3,0,0.5,0,0.7
                          c0,0.8,0,1.7,0,2.5c0,0.4,0.1,0.6,0.6,0.6c2.1-0.1,4.1-0.4,6.1-1c5-1.5,9.1-4.2,12.5-8.1C19.9,14.2,19.9,14.2,19,13.5z"/>
                      <path class="st1" d="M9.1,12.3c0.1-0.1,0.1-0.2,0-0.3c-1.2-0.9-2.4-1.7-3.5-2.5C5.4,9.4,5.3,9.2,5.2,9.3
                          c-0.1,0-0.1,0.1-0.1,0.2v0.2v4.5C6.8,14.1,8.2,13.1,9.1,12.3z"/>
                      </svg>
                    </div>`;
    }

    return(
      <div key="1">
        <div dangerouslySetInnerHTML={ { __html: htmlContent } } onClick={editAddon}/>
        {/*<div dangerouslySetInnerHTML={ { __html: addon.htmlContent } } />*/}
      </div>
    )
  }
}

export default AddonContent;



// WEBPACK FOOTER //
// ./src/components/AddonContent.js